import { memo } from "react";
import { useUnit } from "effector-react";
import {
  $UserAddPermissions,
  ACTIONS,
  UserPriorityEnum,
} from "@store/user-store";

import { InternalStudyStudentsTable } from "@components/tables";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import style from "./students.module.scss";

const InternalStudents = memo(() => {
  const permissions = useUnit($UserAddPermissions);

  return (
    <div
      className={clsx(
        style.content,
        !permissions.hasPermission(
          ACTIONS.educationalCenter_internalTraining_list_allowedToCreate
        )
          ? style.no_btn
          : ""
      )}
    >
      <div className={style.head}>
        <div className={style.tabs}>
          {permissions.hasPermission(
            ACTIONS.educationalCenter_internalTraining_list_allowedToShow
          ) && (
            <NavLink to="/study-center/internal/list">Список обучений</NavLink>
          )}
          <div className={style.tabs_active}>Список обучающихся</div>
          {permissions.hasPermission(
            ACTIONS.educationalCenter_internalTraining_list_allowedToShow
          ) && (
            <NavLink to="/study-center/internal/comission">Комиссии</NavLink>
          )}
          {permissions.hasPermission(
            ACTIONS.educationalCenter_internalTraining_programs_allowedToShow
          ) && (
            <NavLink to="/study-center/internal/programs">
              Программы обучений
            </NavLink>
          )}
          {permissions.hasRequiredLevel(UserPriorityEnum.Owner) && (
            <NavLink to="/study-center/internal/courses">Курсы</NavLink>
          )}
        </div>
      </div>
      <InternalStudyStudentsTable />
    </div>
  );
});

export default InternalStudents;
